import { PaymentCertificateStateTypes, PaymentCertificateActionTypes } from "./PaymentCertificate.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PaymentCertificateStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PostCheckReducer = (
  state: PaymentCertificateStateTypes = INITIAL_STATE,
  action: any
): PaymentCertificateStateTypes => {
  switch (action.type) {
    case PaymentCertificateActionTypes.FETCH_ALL_PAYMENT_CERTIFICATE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PaymentCertificateActionTypes.FETCH_ALL_PAYMENT_CERTIFICATE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PaymentCertificateActionTypes.FETCH_ALL_PAYMENT_CERTIFICATE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PaymentCertificateActionTypes.FETCH_ALL_PAYMENT_CERTIFICATE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PaymentCertificateActionTypes.FETCH_ONE_PAYMENT_CERTIFICATE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PaymentCertificateActionTypes.FETCH_ONE_PAYMENT_CERTIFICATE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PaymentCertificateActionTypes.FETCH_ONE_PAYMENT_CERTIFICATE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PaymentCertificateActionTypes.FETCH_ONE_PAYMENT_CERTIFICATE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PostCheckReducer;
